import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import { Hotel } from '@hotels/hotels-home/entities/hotel';
import { Destination } from '@hotels/hotels-home/entities/destination';
import { PopularPlace } from '@hotels/hotels-home/entities/popular-place';

export const fetchPopularDestinationsAction = createAction(type('[Hotels/API] Fetch popular destinations'));
export const fetchPopularDestinationsSuccessAction = createAction(type('[Hotels/API] Fetch popular destinations success'),
  props<{ destinations: Destination[] }>());
export const fetchPopularHotelsAction = createAction(type('[Hotels/API] Fetch popular hotels'));
export const fetchPopularHotelsSuccessAction = createAction(type('[Hotels/API] Fetch popular hotels success'),
  props<{ hotels: Hotel[] }>());
export const fetchPopularPlacesAction = createAction(type('[Hotels/API] Fetch popular places'));
export const fetchPopularPlacesSuccessAction = createAction(type('[Hotels/API] Fetch popular places success'),
  props<{ popularPlaces: PopularPlace[] }>());
